
/*
	enable outline on tab
*/

document.body.addEventListener('keyup', function(e) {
  if (e.which === 9) /* tab */ {
    document.documentElement.classList.remove('no-focus-outline');
  }
});


const selectors = document.querySelectorAll('.selector');

function show(el) {
	el.style.display = "block";
}

function hide(el) {
	el.style.display = "none";
}

function isPlaceholder(el) {
  if(el.getAttribute('disabed') && el.getAttribute("hidden")) {
  	return true;
  }
  return false;
}


window.addEventListener('click', function(e) {
	
  Array.from(document.querySelectorAll('.selector-container ul')).forEach(function(el){
    el.style.display = "none";
  });
});

Array.from(selectors).forEach(function (selector) {

	const options = selector.querySelectorAll('option');
  
  	const container = document.createElement('DIV');
  
  	container.setAttribute('class', 'selector-container');
  
  	const placeholder = document.createElement('DIV');
  
  	placeholder.innerHTML = "Please select";
  
  	container.appendChild(placeholder);
  
  	const optionsContainer = document.createElement('UL');
  
  	optionsContainer.classList.add('options-container');
  	
  	hide(optionsContainer);
  
    Array.from(options).forEach(function(option) {
      
      if(isPlaceholder(option) || option.style.display == "none") {
      	return;
      } 
      
      const optionHTML = document.createElement('LI');

      optionHTML.innerHTML = option.innerHTML;
      
      if(option.style.backgroundImage) {
      	optionHTML.style.backgroundImage = option.style.backgroundImage;
        optionHTML.classList.add("background-image");
      }
      
      optionHTML.addEventListener('click', function() {

        var deviceAgent = navigator.userAgent.toLowerCase();
    var agentID = deviceAgent.match(/(iPad|iPhone|iPod)/i);

        
        if(option.style.backgroundImage) {
          placeholder.style.backgroundImage = option.style.backgroundImage;
          placeholder.classList.add("background-image");
          placeholder.innerHTML = "&nbsp;";
        } else {
			placeholder.innerHTML = optionHTML.innerHTML.toUpperCase();
		}
        
        hide(optionsContainer);
        
        if(agentID){
         var otprj = $(this).parent().parent().parent().find('select').attr('id');
        $('#'+otprj).val($.trim(optionHTML.innerHTML));
        }
        else{
        Array.from(options).forEach(function(option) {option.removeAttribute('selected');})
        option.setAttribute('selected', "true");
          }
      });
      
      optionsContainer.appendChild(optionHTML);
    });
  
  	placeholder.addEventListener("click", function(e) {
      	e.stopPropagation();
      	Array.from(document.querySelectorAll('.options-container')).forEach(hide);
      	show(optionsContainer);
    });
  	
	container.appendChild(optionsContainer);
  	selector.appendChild(container);
 
  	
});


// handles images in product

(function () {
	
  function show(el) {
    if(!el) {
    	return;
    }
  	el.style.display = "block";
  }
  
  function hide(el) {
    if(!el) {return;}
    el.style.display = "none";
  }
  	
  	const images = Array.from(document.querySelectorAll('.images li'));
  	const bullets = Array.from(document.querySelectorAll('.images > .bullets > span'));
  
  function showBullet(index) {
  	bullets.forEach(el => {el.classList.remove('active');});
    bullets[index].classList.add('active')
  }

	bullets.forEach(function(bullet, index) {
      bullet.addEventListener('click', function() {
        images.forEach(hide);
       	show(images[index]);
        showBullet(index);
      });
    });
                               
	images.forEach(function(image, index) {
    	
      image.addEventListener('click', function() {
        hide(image);
        
        let next = images[index + 1];
        
        if(!next) {
        	next = images[0];
          	showBullet(0);
        } else {
        	showBullet(index + 1);
        }
        
        show(next);
      });
    });
  
})();
